<template>
  <div>
    <br />
    <br />
    <br />
    <div class="columns is-mobile is-centered">
      <div class="column is-half">
        <center>
          <h1 class="title" style="color:#004771">Claims Reporting</h1>
          <h2 class="subtitle">The easiest way to report a claim is online.</h2>
        </center>
        <br />
        <br />
        <br />

        <div class="columns">
          <div class="column">
            <center>
                <h5 class="title is-5">Republic Website Login</h5>

                <div class="subtitle is-7">Existing users login to your account to access claims reporting and other policy information.  Click Register to create a new account.</div>

              <!-- <div class="subtitle is-6">Log in to your Republic account to report a claim.</div> -->

              <b-button
                tag="a"
                href="/account-management"
                class="is-warning"
                size="is-medium"
                icon-left="lock"
              >Policyholder Login</b-button>
              <div>
                <a href="/ph/registration">Register</a>
              </div>
            </center>
          </div>
          <div class="is-divider-vertical" data-content="OR"></div>
          <div class="column">
            <center>
              <h5 class="title is-5">Report a claim without logging in.</h5>
              <br />
              <br />
              <b-button
                tag="router-link"
                to="/eclaim"
                class="is-warning"
                size="is-medium"
                icon-left="lock-open"
              >
                Continue as
                Guest
              </b-button>
            </center>
          </div>
        </div>
        <center>
          <b>You have a variety of options for reporting a claim:</b>
          <br />24/7 Call Center at 888-336-7569
          <br />Claims email:
          <a href="mailto:riclaims@ri-net.com">riclaims@ri-net.com</a>
        </center>
      </div>      
    </div>
<div style="max-width: 600px; margin: 30px auto; border: 1px solid #ddd; border-radius: 10px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); padding: 20px; background-color: #e8eff4; text-align: center;">
<h3 style="margin-top: 0; font-size: 1.6em; color: #173966;"><strong>Report a Claim Online in Minutes</strong></h3>
<div style="position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; border-radius: 8px;">
<iframe src="https://play.vidyard.com/bpwLMRgyJWLMgxrmhvK9An.html" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none; border-radius: 8px;" allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" title="Submit New Business Video">
</iframe>
</div>
<p style="margin: 10px 0 0 0; font-size: 1em; color: #333; line-height: 1.4;">
Learn how to quickly file your claim online with this step-by-step guide.
</p>
</div> 

  </div>
</template>

<script>
export default {
  name: "claimsreporting",
  data() {
    return {
      firstname: null
    };
  },
  computed: {},
  methods: {}
};
</script>

<style>
</style>
